
























































































import { mapGetters } from "vuex";
export default {
  name: 'TopMenuMember',
  computed: {
    ...mapGetters({
      getCustomerType: "getCustomerType"
    })
  }
}
